import Animate from '@wwdev/animate/Animate.js';
new Animate();
